import apiEndpoints from "../config/apiEndpoints";
import axiosInstance from "../api/axiosInstance";
import { vereist, spoor } from './verzoek';

// Elke dienst hieronder zegt wat hij nodig heeft, zegt wat hij ophaalt, en doet dat. Gaat er
// iets mis, dan gooit hij: de aanroeper weet als enige wat de gast op dat moment hoort te zien.
// Het naar Sentry sturen gebeurt in de onderschepper van axios, op een plek. (WI5)

export const getLanguageDetails = async (key) => {
    vereist('getLanguageDetails', { key });

    spoor("Fetching language details", { key });

    return axiosInstance.get(apiEndpoints.GET_LANGUAGE(key));
};

export const getWidgetSettings = async (language, key) => {
    vereist('getWidgetSettings', { key, language });

    spoor("Fetching widget settings", { key, language });

    return axiosInstance.get(apiEndpoints.GET_WIDGET_SETTING(language, key));
};

export const getWidgetTitleandInfo = async (setupID, language) => {
    vereist('getWidgetTitleandInfo', { setupID, language });

    spoor("Fetching widget title and info", { setupID, language });

    return axiosInstance.get(
        apiEndpoints.GET_WIDGET_TITLE_AND_INFO(setupID, language)
    );
};

export const getWidgetSetUpPosition = async (ID) => {
    vereist('getWidgetSetUpPosition', { ID });

    spoor("Fetching widget setup position", { ID });

    return axiosInstance.get(apiEndpoints.GET_WIDGET_POSITION(ID));
};

export const getCalenderDatas = async (key, noOfGuests, widgetId, reservationRequestMin) => {
    vereist('getCalenderDatas', { key, widgetId });

    spoor("Fetching calendar data", { key, noOfGuests, widgetId });

    return axiosInstance.get(
        apiEndpoints.GET_CALENDER_DETAILS(key, noOfGuests, widgetId, reservationRequestMin = 0)
    );
};

export const getReservationType = async (data) => {
    vereist('getReservationType', { data });

    spoor("Fetching reservation type", { data });

    return axiosInstance.post(apiEndpoints.GET_RESERVATION_TYPE, data);
};

export const getReservationGroup = async (data) => {
    vereist('getReservationGroup', { data });

    spoor("Fetching reservation group", { data });

    return axiosInstance.post(apiEndpoints.GET_RESERVATION_GROUP_TYPE, data);
};

export const getFreeTables = async (data) => {
    vereist('getFreeTables', { data });

    spoor("Fetching free tables", { data });

    return axiosInstance.post(apiEndpoints.GET_FREE_TABLES, data);
};

// De sms-uitnodiging achter de korte link: datum, aantal, soort, tijden en telefoon. Bij 404/403 gooit axios; de aanroeper leest
// error.response.data.fout. Niets uit het antwoord en de code niet in het spoor.
export const getSmsUitnodiging = async (key, code, lang) => {
    vereist('getSmsUitnodiging', { key, code });

    spoor("Fetching sms invitation", { key });

    return axiosInstance.get(apiEndpoints.GET_SMS_UITNODIGING(key, code, lang));
};

export const getReservationTypeBasedOnProducts = async (key, id) => {
    vereist('getReservationTypeBasedOnProducts', { key, id });

    spoor("Fetching reservation type based on products", { key, id });

    const antwoord = await axiosInstance.get(
        apiEndpoints.GET_PRODUCTS_RESERVATION_TUPE(key, id)
    );

    return antwoord.data;
};

export const getGuestDetails = async (key, ID, lang,mainModuleId) => {
    vereist('getGuestDetails', { key, ID });

    spoor("Fetching guest details", { key, ID, lang, mainModuleId });

    return axiosInstance.get(apiEndpoints.GET_GUEST_DETAILS(key, ID, lang,mainModuleId));
};

export const getExtraFieldDetails = async (resID, lang, key,widgetId) => {
    vereist('getExtraFieldDetails', { resID, key });

    spoor("Fetching extra field details", { resID, lang });

    const antwoord = await axiosInstance.get(
        apiEndpoints.GET_EXTRA_INFO_FIELDS(resID, lang, key,widgetId)
    );

    return antwoord.data;
};

export const getExtraProductDetails = async (ID, lang,key) => {
    vereist('getExtraProductDetails', { ID });

    spoor("Fetching extra product details", { ID, lang,key });

    return axiosInstance.get(apiEndpoints.GET_EXTRA_PRODUCTS_DETAILS(ID, lang,key));
};

export const transactionCostForReservation = async (key, ID, lang) => {
    vereist('transactionCostForReservation', { key, ID });

    spoor("Fetching transaction cost", { key, ID, lang });

    return axiosInstance.get(apiEndpoints.TRANSACTIONCOST_RESTYPE(key, ID, lang));
};

export const createReservation = async (data) => {
    vereist('createReservation', { data });

    spoor("Creating reservation", { data });

    return axiosInstance.post(apiEndpoints.CREATE_RESERVATION, data);
};

export const getReservationDetails = async (ID, secretkey, mainModuleId) => {
    vereist('getReservationDetails', { ID, secretkey });

    spoor("Fetching reservation details", { ID, mainModuleId });

    return axiosInstance.get(
        apiEndpoints.GET_RESERVATION_DETAILS(ID, secretkey, mainModuleId)
    );
};

export const cancelReservation = async (key, secretKey, payload) => {
    vereist('cancelReservation', { key, secretKey });

    spoor("Cancelling reservation", { key, remarks: payload?.remarks });

    return axiosInstance.delete(apiEndpoints.CANCEL_RESERVATION, {
        data: { key, secretKey, remarks: payload?.remarks },
    });
};

export const GetOpeningHours = async (key, lang, url) => {
    vereist('GetOpeningHours', { key });

    spoor("Fetching opening hours", { lang, url });

    const antwoord = await axiosInstance.get(apiEndpoints.GET_OPENING_HOURS(key, lang, url));

    return antwoord.data;
};

export const FetchWidgetConfigDetails = async (key, id, lang, guestid) => {
    vereist('FetchWidgetConfigDetails', { key, id });

    spoor("Fetching widget config details", { id, lang, guestid });

    return axiosInstance.get(
        apiEndpoints.GET_WIDGETS_CONFIG(key, id, lang, guestid)
    );
};

// Deze haalt de pdf van een reservering op. Hij blijft bewust anders dan de rest: ook als de api
// een fout teruggeeft kan er een bruikbare pdf in dat antwoord zitten, en dan wil de gast die zien
// in plaats van een melding. Wat er wel weg is: de melding bij succes, en de sleutel gaat nog
// steeds niet mee in het spoor. (WI5)
export const getReservationPdf = async (key, secretkey, mainModuleId) => {
    vereist('getReservationPdf', { key, secretkey });

    spoor("Fetching reservation PDF", { mainModuleId });

    const uitpakken = (gegevens) => {
        const pdf = gegevens?.pdf ?? null;
        const reservationNumber = gegevens?.reservationNumber ?? null;

        if (!pdf && !reservationNumber) return null;

        if (pdf?.startsWith("data:application/pdf;base64,")) {
            return { pdf: pdf.split(",")[1], reservationNumber };
        }

        return { pdf, reservationNumber };
    };

    try {
        const antwoord = await axiosInstance.get(
            apiEndpoints.GET_RESERVATION_PDF(key, encodeURIComponent(secretkey), mainModuleId),
            { headers: { "Content-Type": "application/json" } }
        );

        return uitpakken(antwoord?.data);
    }
    catch (fout) {
        const alsnog = uitpakken(fout?.response?.data);

        // Zat er geen pdf in het antwoord, dan is dit gewoon een fout en hoort de aanroeper dat te
        // merken.
        if (!alsnog) throw fout;

        return alsnog;
    }
};

export const GetGuestDetailsByKey = async (token, key, guestId) => {
    vereist('GetGuestDetailsByKey', { token });

    spoor("Fetching guest details by key", { guestId });

    const antwoord = await axiosInstance.get(apiEndpoints.GET_GUEST_DETAILS_BYKEY(key, guestId), {
        headers: { "api-key": token },
    });

    return antwoord.data;
};

export const AuthLogin = async (data) => {
    vereist('AuthLogin', { data });

    spoor("Authenticating user", { data });

    return axiosInstance.post(apiEndpoints.AUTH_LOGIN, data);
};

